import {
  ShipmentEntryType,
  LabelOptionsModel,
  LabelOptionsRewriteModel,
  DropOffType,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

export const isReturnShipment = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
) => {
  return (
    labelOptions?.shipmentEntryType === ShipmentEntryType.Return ||
    labelOptionsRewrite?.shipmentEntryType === ShipmentEntryType.Return
  )
}

export const isPackageTypeLabelTypeFlow = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
) => {
  if (labelOptionsRewrite?.dropOffs) {
    const hasFreeReusablePackaging = labelOptionsRewrite.dropOffs.some(dropOff =>
      dropOff.options?.some(option => option.freeReusablePackagingAvailable),
    )

    const hasMultipleUniqueLabelTypes =
      [
        ...new Set(
          labelOptionsRewrite.dropOffs.flatMap(dropOff =>
            (dropOff.options ?? []).flatMap(option => option.labelTypes ?? []),
          ),
        ),
      ].length > 1

    return hasFreeReusablePackaging && hasMultipleUniqueLabelTypes
  }

  if (
    Array.isArray(labelOptions?.availableLabelTypes) &&
    labelOptions.availableLabelTypes.length > 1 &&
    Array.isArray(labelOptions?.dropOffTypes) &&
    labelOptions.dropOffTypes.length > 1
  ) {
    return true
  }

  return false
}

export const isOldDropOffPointTypeFlow = (labelOptions?: LabelOptionsModel) => {
  return Array.isArray(labelOptions?.dropOffs) && labelOptions.dropOffs.length > 1
}

export const isDropOffTypeFlow = (
  labelOptionsRewrite?: LabelOptionsRewriteModel,
  labelOptions?: LabelOptionsModel,
) => {
  if (labelOptionsRewrite?.dropOffs) {
    return Array.isArray(labelOptionsRewrite?.dropOffs) && labelOptionsRewrite.dropOffs.length > 1
  }

  return labelOptions?.dropOffTypes && labelOptions?.dropOffTypes.length > 1
}

export const isMultipleDropOffOptions = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
) => {
  if (labelOptionsRewrite?.dropOffs) {
    return labelOptionsRewrite.dropOffs.some(
      dropOff => dropOff.options && dropOff.options.length > 1,
    )
  }

  return !!(labelOptions?.dropOffTypes && labelOptions.dropOffTypes.length > 1)
}

export const isDigitalLabelFlowEnabled = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
) => {
  if (labelOptionsRewrite?.dropOffs) {
    return (
      !!labelOptionsRewrite?.dropOffs &&
      [
        ...new Set(
          labelOptionsRewrite.dropOffs.flatMap(dropOff =>
            (dropOff.options ?? []).flatMap(option => option.labelTypes ?? []),
          ),
        ),
      ].length > 1
    )
  }

  if (Array.isArray(labelOptions?.availableLabelTypes)) {
    return labelOptions.availableLabelTypes.length > 1
  }

  return false
}

export const isReusablePackagingFlowEnabled = (labelOptionsRewrite: LabelOptionsRewriteModel) => {
  return !!labelOptionsRewrite?.dropOffs?.find(dropOff =>
    dropOff.options?.some(option => option.freeReusablePackagingAvailable),
  )
}

export const getDefaultselectedDropOffPointType = (labelOptions?: LabelOptionsModel) =>
  labelOptions?.dropOffs?.length === 1 ? labelOptions?.dropOffs[0]?.type : undefined

export const getDropOffPointType = (
  labelOptions?: LabelOptionsModel,
  labelOptionsRewrite?: LabelOptionsRewriteModel,
  selectedDropOffTypeKey?: number | string | null,
  selectedDropOffPointType?: number | null,
) => {
  if (
    labelOptionsRewrite &&
    (selectedDropOffTypeKey === DropOffType.Point ||
      selectedDropOffTypeKey === DropOffType.Home ||
      selectedDropOffTypeKey === DropOffType.Mailbox)
  ) {
    return selectedDropOffTypeKey
  }

  if (labelOptions && selectedDropOffPointType) {
    return selectedDropOffPointType
  }

  const defaultSelectedDropOffPointType = getDefaultselectedDropOffPointType()

  if (labelOptions && defaultSelectedDropOffPointType) {
    return defaultSelectedDropOffPointType
  }

  return null
}
